import { useState, useEffect, useCallback } from 'react'

export const useGetUsers = (params = {}) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [cursor, setCursor] = useState(null)
  const [hasMore, setHasMore] = useState(true)

  const fetchData = useCallback(async (append = false, startAfterVal = null) => {
    setIsLoading(true)

    try {
      const queryParams = { ...params }
      if (startAfterVal) {
        queryParams.startAfter = startAfterVal
      }

      const queryString = new URLSearchParams(queryParams).toString()
      const response = await fetch(`/api/users?${queryString}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`)
      }

      const json = await response.json()
      const results = Array.isArray(json) ? json : []

      if (append) {
        setData((prev) => [...prev, ...results])
      } else {
        setData(results)
      }

      if (params.limit && results.length > 0) {
        const lastUser = results[results.length - 1]
        setCursor(lastUser.username || null)
        setHasMore(results.length === parseInt(params.limit, 10))
      } else {
        setHasMore(false)
      }
    } catch (error) {
      console.error(error)
      setHasMore(false)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  const loadMore = useCallback(() => {
    if (!hasMore || isLoading || !cursor) return
    fetchData(true, cursor)
  }, [hasMore, isLoading, cursor, fetchData])

  return { users: data, isLoading, hasMore, loadMore, refetch: fetchData }
}
